//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import {
  GET_TOOLS,
  ADD_TOOL,
  DELETE_TOOL,
  TOOLS_LOADING
} from "../actions/types";

const initialState = {
  tools: [],
  loading: false
  // when we fetch data takes some ms to get
};

//will later get state from api

export default function(state = initialState, action) {
  switch (action.type) {
    // checking action from itemActions -> type is name of action
    case GET_TOOLS:
      return {
        ...state,
        tools: action.payload,
        loading: false
        // before request items_loading was set to true
      };
    case DELETE_TOOL:
      return {
        ...state,
        tools: state.tools.filter(tool => tool._id !== action.payload)
      };
    case ADD_TOOL:
      return {
        ...state,
        tools: [action.payload, ...state.tools]
        // ... -> because hardcopy we cannot modify it
      };
    case TOOLS_LOADING:
      return {
        ...state,
        loading: true
        // ... -> because hardcopy we cannot modify it
      };
    default:
      return state;
  }
}
